import React from "react";
import Link from "../../Link";

export default class TrudatLightTough extends React.Component {
  render() {
    return (
      <section className="hp__block hp__block--light-tough container text-center">
        <Link className="hp__block__light-tough-link" to="/c/338,twardo">
          {" "}
          <span> TWARDO </span>{" "}
        </Link>{" "}
        <Link className="hp__block__light-tough-link" to="/c/339,lekko">
          {" "}
          <span> LEKKO </span>{" "}
        </Link>
      </section>
    );
  }
}
